import { Drawer, DrawerHeader, IconButton, } from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import React, { useEffect, useState } from 'react';
import { SubmitSuspendCartRequest, } from '../../../api/oms/edit-pickup-location';
import { getWindow } from '../../../utils/general';
import '../../../styles/drawer.scss';
import { EditPickupLocationStoreSelection } from './EditPickupLocationStoreSelection';
import { EditPickupLocationConfirmation } from './EditPickupLocationConfirmation';
import { EditPickupLocationSurvey } from './EditPickupLocationSurvey';
import { useExperienceContext } from '../../../hooks/useContexts';
export var EditPickupLocationDrawer = function (_a) {
    var _b;
    var open = _a.open, setOpen = _a.setOpen, skeletonLoading = _a.skeletonLoading, setDrawerError = _a.setDrawerError, fulfillmentGroup = _a.fulfillmentGroup, orderId = _a.orderId, customerType = _a.customerType, fulfillmentType = _a.fulfillmentType, orderDetailsData = _a.orderDetailsData, storeLocationData = _a.storeLocationData, handleButtonClick = _a.handleButtonClick, alertState = _a.alertState, fulfillmentGroupIndex = _a.fulfillmentGroupIndex;
    var _c = useState(true), isStoreSelection = _c[0], setIsStoreSelection = _c[1];
    var _d = useState(false), isConfirmation = _d[0], setIsConfirmation = _d[1];
    var _e = useState(false), isSurvey = _e[0], setIsSurvey = _e[1];
    var _f = useState(false), isLocationChangeConfirmed = _f[0], setIsLocationChangeConfirmed = _f[1];
    var _g = useState(), suspendCartData = _g[0], setSuspendCartData = _g[1];
    var _h = useState(), selectedStoreData = _h[0], setSelectedStoreData = _h[1];
    var _j = useState(), editPickupLocationOrderIds = _j[0], setEditPickupLocationOrderIds = _j[1];
    var isConsumerApp = useExperienceContext().isConsumerApp;
    var isIos = ((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.navigator.userAgent.includes('Mac')) || false;
    var isIosMobile = isIos && isConsumerApp;
    var suspendCartCheck = function () {
        if (suspendCartData && !isLocationChangeConfirmed) {
            SubmitSuspendCartRequest(suspendCartData, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId);
            setSuspendCartData(undefined);
        }
    };
    var closeDrawer = function () {
        var _a, _b;
        setOpen(false);
        setIsConfirmation(false);
        setIsSurvey(false);
        setIsStoreSelection(true);
        suspendCartCheck();
        if (isLocationChangeConfirmed) {
            setIsLocationChangeConfirmed(false);
            (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.reload();
        }
    };
    useEffect(function () {
        var _a;
        var onBeforeUnload = function () {
            suspendCartCheck();
        };
        (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.addEventListener('beforeunload', onBeforeUnload);
        return function () {
            var _a;
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.removeEventListener('beforeunload', onBeforeUnload);
            suspendCartCheck();
        };
    }, []);
    useEffect(function () {
        if (selectedStoreData) {
            setSuspendCartData({
                cartId: selectedStoreData.storeInfo.newOrder.cartId,
                orderId: orderId,
                emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
                fulfillmentType: fulfillmentType,
                net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
            });
            setIsStoreSelection(false);
            setIsConfirmation(true);
        }
    }, [selectedStoreData]);
    useEffect(function () {
        var _a;
        if (editPickupLocationOrderIds) {
            (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage.setItem('editPickupLocationOrderIds', JSON.stringify(editPickupLocationOrderIds));
        }
    }, [editPickupLocationOrderIds]);
    return (React.createElement(Drawer, { open: open, onClose: closeDrawer, position: "right" },
        React.createElement(DrawerHeader, { title: "Edit Pickup Location", endAdornment: React.createElement(IconButton, { "aria-label": "drawer-close", onClick: closeDrawer, icon: Close }) }),
        isStoreSelection && (React.createElement(EditPickupLocationStoreSelection, { skeletonLoading: skeletonLoading, closeDrawer: closeDrawer, setDrawerError: setDrawerError, fulfillmentGroupIndex: fulfillmentGroupIndex, setSelectedStoreData: setSelectedStoreData, fulfillmentGroup: fulfillmentGroup, orderId: orderId, fulfillmentType: fulfillmentType, orderDetailsData: orderDetailsData, storeLocationData: storeLocationData, handleButtonClick: handleButtonClick, alertState: alertState })),
        isConfirmation && selectedStoreData && (React.createElement(EditPickupLocationConfirmation, { closeDrawer: closeDrawer, setIsStoreSelection: setIsStoreSelection, setIsConfirmation: setIsConfirmation, fulfillmentGroupIndex: fulfillmentGroupIndex, setIsSurvey: setIsSurvey, setDrawerError: setDrawerError, setIsLocationChangeConfirmed: setIsLocationChangeConfirmed, suspendCartCheck: suspendCartCheck, isIosMobile: isIosMobile, fulfillmentGroup: fulfillmentGroup, orderId: orderId, fulfillmentType: fulfillmentType, orderDetailsData: orderDetailsData, selectedStoreData: selectedStoreData, setEditPickupLocationOrderIds: setEditPickupLocationOrderIds })),
        isSurvey && (React.createElement(EditPickupLocationSurvey, { closeDrawer: closeDrawer, isIosMobile: isIosMobile, fulfillmentGroup: fulfillmentGroup, orderId: orderId, fulfillmentType: fulfillmentType, orderDetailsData: orderDetailsData, customerType: customerType, newStoreNumber: selectedStoreData === null || selectedStoreData === void 0 ? void 0 : selectedStoreData.storeInfo.newOrder.storeNumber }))));
};
